import React, { useEffect, useState } from 'react';
import api from '../../api';
import AdminSectionHeader from '../../components/admin/AdminSectionHeader';
import StatusMessage from '../../components/admin/StatusMessage';

export default function BlogsPage() {
  const [pendingBlogs, setPendingBlogs] = useState([]);
  const [msg, setMsg] = useState({ type: '', text: '' });

  useEffect(() => {
    loadBlogs();
  }, []);

  const loadBlogs = () => {
    api.get('/api/admin/blogs/pending')
      .then((r) => setPendingBlogs(r.data || []))
      .catch(() => setMsg({ type: 'error', text: 'Failed to load pending blogs' }));
  };

  const showMsg = (type, text, duration = 3000) => {
    setMsg({ type, text });
    setTimeout(() => setMsg({ type: '', text: '' }), duration);
  };

  const approveBlog = async (id) => {
    try {
      await api.post(`/api/admin/blogs/${id}/approve`);
      setPendingBlogs((b) => b.filter((x) => x.id !== id));
      showMsg('success', 'Blog approved');
    } catch {
      showMsg('error', 'Failed to approve blog');
    }
  };

  const rejectBlog = async (id) => {
    const reason = window.prompt('Enter rejection reason (optional):', '');
    try {
      await api.post(`/api/admin/blogs/${id}/reject`, { reason });
      setPendingBlogs((b) => b.filter((x) => x.id !== id));
      showMsg('success', 'Blog rejected');
    } catch {
      showMsg('error', 'Failed to reject blog');
    }
  };

  return (
    <div className="admin-blogs-page">
      <AdminSectionHeader
        title="Review Blogs"
        subtitle="Moderate pending blog submissions"
      />

      {msg.text && <StatusMessage type={msg.type} message={msg.text} />}

      {pendingBlogs.length === 0 ? (
        <p className="empty-state">No pending blogs to review.</p>
      ) : (
        <ul className="blogs-list">
          {pendingBlogs.map((b) => (
            <li key={b.id} className="blog-item">
              <div className="blog-info">
                <h4>{b.title}</h4>
                <div className="blog-meta">
                  <span>by {b.author_name || 'Anonymous'}</span>
                  <span className="blog-date">{new Date(b.created_at).toLocaleString()}</span>
                </div>
                {b.content && (
                  <p className="blog-preview">{b.content.substring(0, 200)}...</p>
                )}
              </div>
              <div className="blog-actions">
                <button
                  type="button"
                  className="btn btn-success btn-sm"
                  onClick={() => approveBlog(b.id)}
                  title="Approve"
                >
                  <i className="fa-solid fa-check"></i> Approve
                </button>
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={() => rejectBlog(b.id)}
                  title="Reject"
                >
                  <i className="fa-solid fa-xmark"></i> Reject
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}